export default function MotoDetails() {
    return <div>Moto Details</div>
}